import PropTypes from "prop-types";
import { Paper, Typography } from "@mui/material";
import { get_root_value } from "src/utils/domUtils";

SearchNotFound.propTypes = {
  searchQuery: PropTypes.string,
};

export default function SearchNotFound({ searchQuery = "", ...other }) {
  return (
    <Paper {...other}>
      <Typography
        sx={{
          backgroundColor: get_root_value("--background-secondary-color"),

          color: get_root_value("--audio-color"),
        }}
        variant="h5"
        align="center"
      >
        No results found
      </Typography>
    </Paper>
  );
}
